import { IPoint } from '../../../../../../../../graphql/lenses/models/get-lenses.models';

export const getAcuvuePoints = (points?: IPoint[] | null): number[] => {
  return (points ?? []).reduce((initialArray: number[], { acuvuePoints }) => {
    return [...initialArray, acuvuePoints];
  }, []);
};
